import { fork } from 'redux-saga/effects';

import { apiVersionFetchSaga } from './apiVersionFetch.saga';

export function* settingsSagas() {
	yield fork(apiVersionFetchSaga);
}
